import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";

export default function MainLayout(props: any) {
  const { children } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  // Check if current page is EventDetailPublic
  const isEventDetailPage = location.pathname.includes("/event/");
  const shouldHideHeader = isMobile && isEventDetailPage;


  return <Box sx={{ p: shouldHideHeader ? 0 : 2 }}>{children}</Box>;
}
